/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { GadgetDirectoryResourceData } from '@jira/global-pages__dashboard-common/src/types.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

const getGadgetDirectoryData = async (): Promise<GadgetDirectoryResourceData | null> =>
	performGetRequest('/rest/config/1.0/directoryitems.json');

export default getGadgetDirectoryData;
